import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "g-container hidden sm:block" }
const _hoisted_2 = { class: "g-container flex flex-col sm:mt-10 p-[16px] sm:p-0 gap-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "category" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("管理我的收藏 ")
const _hoisted_7 = { class: "filter-search flex right-[calc((100vw_-_305px)_/_2)] sm:right-0 w-[150px] sm:w-[273px]" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = { class: "text-xs text-gary-text-color leading-[50px]" }
const _hoisted_11 = { class: "flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_ProductClassItemList = _resolveComponent("ProductClassItemList")!
  const _component_ProductItemList = _resolveComponent("ProductItemList")!
  const _component_ProductItemListWithSelect = _resolveComponent("ProductItemListWithSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, {
        title: _ctx.contentType,
        class: "mt-8 g-title-type2"
      }, null, 8, ["title"]),
      (_ctx.contentType === _ctx.ContentType.normal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "cursor-pointer flex items-center gap-1 text-sm text-gary-text-color tracking-[.06em] leading-[40px]",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.manageCollectList(_ctx.ContentType.edit)))
                }, [
                  _createVNode(_component_Icon, {
                    iconName: "garbage-can",
                    width: '24px'
                  }),
                  _hoisted_6
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_SearchInput, {
                    getInput: _ctx.getInput,
                    "onUpdate:getInput": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getInput) = $event))
                  }, null, 8, ["getInput"])
                ])
              ]),
              _createVNode(_component_ProductClassItemList, {
                sourceType: 'collect',
                class: "mt-3"
              })
            ]),
            _createVNode(_component_ProductItemList, { class: "hidden sm:block mt-[36px] sm:mt-[30px]" }),
            _createVNode(_component_ProductItemList, {
              class: "sm:hidden mt-[15px] sm:mt-[30px]",
              row: 2,
              isMobile: true
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.contentType === _ctx.ContentType.edit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, " 已選 " + _toDisplayString(_ctx.getSelectedItem.length) + " 個商品 ", 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Icon, {
                  onClick: _ctx.delCmdyCollect,
                  class: "cursor-pointer",
                  iconName: "delete_word",
                  width: "50px"
                }, null, 8, ["onClick"]),
                _createVNode(_component_Icon, {
                  onClick: _ctx.allItemSelect,
                  class: "cursor-pointer",
                  iconName: "choose_word",
                  width: "50px"
                }, null, 8, ["onClick"]),
                _createVNode(_component_Icon, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
              _ctx.manageCollectList(_ctx.ContentType.normal)
            )),
                  class: "cursor-pointer",
                  iconName: "complete_word",
                  width: "50px"
                })
              ])
            ]),
            _createVNode(_component_ProductItemListWithSelect, { class: "hidden sm:block mt-[36px] sm:mt-[30px]" }),
            _createVNode(_component_ProductItemListWithSelect, {
              class: "sm:hidden mt-[15px] sm:mt-[30px]",
              row: 2,
              isMobile: true
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}